'use strict';

exports.__esModule = true;
var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = exports.config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

exports.default = configureObservable;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/setObservableConfig.js
// module id = 1518
// module chunks = 62